// // src/components/Price.js
// import React, { useEffect } from 'react';
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import './Price.css'

// const Price = () => {
//   useEffect(() => {
//     AOS.init({ duration: 1000 });
//   }, []);

//   return (
//     <section id="pricing" className="pricing section-bg">
//       <div className="container" data-aos="fade-up">
//         <div className="section-title">
//           <h2>Pricing</h2>
//           <p>
//             Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem. Sit sint
//             consectetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea.
//           </p>
//         </div>

//         <div className="row">
//           <div className="col-lg-4 col-md-6">
//             <div className="box" data-aos="fade-up" data-aos-delay="100">
//               <h3>3 <span>days classes</span></h3>
//               <h4><sup>$</sup>30
//               <span> per hour</span></h4>
//               <ul>
//                 <li>Aida dere</li>
//                 <li>Nec feugiat nisl</li>
//                 <li>Nulla at volutpat dola</li>
//                 <li className="na">Pharetra massa</li>
//                 <li className="na">Massa ultricies mi</li>
//               </ul>
//               <div className="btn-wrap">
//                 <a href="#" className="btn-buy">Buy Now</a>
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-4 col-md-6 mt-4 mt-md-0">
//             <div className="box featured" data-aos="fade-up" data-aos-delay="200">
//               <h3>2 <span>days classes</span></h3>
//               <h4><sup>$</sup>26<span> per hour</span></h4>
//               <ul>
//                 <li>Aida dere</li>
//                 <li>Nec feugiat nisl</li>
//                 <li>Nulla at volutpat dola</li>
//                 <li>Pharetra massa</li>
//                 <li className="na">Massa ultricies mi</li>
//               </ul>
//               <div className="btn-wrap">
//                 <a href="#" className="btn-buy">Buy Now</a>
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-4 col-md-6 mt-4 mt-lg-0">
//             <div className="box" data-aos="fade-up" data-aos-delay="300">
//               <h3>4 <span>days classes</span></h3>
//               <h4><sup>$</sup>25<span>per hour</span></h4>
//               <ul>
//                 <li>Aida dere</li>
//                 <li>Nec feugiat nisl</li>
//                 <li>Nulla at volutpat dola</li>
//                 <li>Pharetra massa</li>
//                 <li>Massa ultricies mi</li>
//               </ul>
//               <div className="btn-wrap">
//                 <a href="#" className="btn-buy">Buy Now</a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Price;
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom'; // Import Link
import AOS from 'aos';
import 'aos/dist/aos.css';
import './styless.css';

const Price = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section id="pricing" className="pricing section-bg">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2 style={{ color: 'black' }}>Pri<span style={{ color: 'orange' }}>cing</span></h2>
          <p>
            Discover our Quran Academy's course pricing. Whether you're looking for Hifz, Tajweed, or other Quranic studies, we offer flexible plans to suit your needs.
          </p>
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-6">
            <div className="box" data-aos="fade-up" data-aos-delay="100">
              <h3>Basic Tajweed Course</h3>
              <h4><sup>$</sup>50 <span> per month</span></h4>
              <ul>
                <li>Introduction to Tajweed</li>
                <li>Daily 1-hour sessions</li>
                <li>Weekly review classes</li>
                <li className="na">Personalized feedback</li>
                <li className="na">Certification upon completion</li>
              </ul>
              <div className="btn-wrap">
                <Link to="/contact-us" className="btn-buy">Enroll Now</Link> {/* Use Link instead of <a> */}
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mt-4 mt-md-0">
            <div className="box featured" data-aos="fade-up" data-aos-delay="200">
              <h3>Advanced Hifz Program</h3>
              <h4><sup>$</sup>100 <span> per month</span></h4>
              <ul>
                <li>Complete Hifz program</li>
                <li>Daily 2-hour sessions</li>
                <li>One-on-one mentoring</li>
                <li>Weekly Quran memorization checks</li>
                <li className="na">Certification and Ijazah</li>
              </ul>
              <div className="btn-wrap">
                <Link to="/contact-us" className="btn-buy">Enroll Now</Link> {/* Use Link instead of <a> */}
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mt-4 mt-lg-0">
            <div className="box" data-aos="fade-up" data-aos-delay="300">
              <h3>Comprehensive Quran Course</h3>
              <h4><sup>$</sup>75 <span> per month</span></h4>
              <ul>
                <li>Quranic Arabic and Tafsir</li>
                <li>Weekly 2-hour classes</li>
                <li>Group discussions</li>
                <li>Personalized learning path</li>
                <li>Certification upon completion</li>
              </ul>
              <div className="btn-wrap">
                <Link to="/contact-us" className="btn-buy">Enroll Now</Link> {/* Use Link instead of <a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Price;
